import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Spinner from '../../components/templates/spinner';
import Translator from '../../services/translate-factory';
import * as Actions from '../../store/actions/general';
import * as actions from '../../store/constants/all';

type OidcLoginPageProps = {
  dispatch?: any;
  match?: any;
  location?: any;
  publicSketches?: boolean;
  general_settings?: any;
};

const IOidcLoginPage: React.FC<OidcLoginPageProps> = ({ dispatch }) => {
  const T = Translator.create();

  useEffect(() => {
    dispatch(Actions.ApiRequest(actions.login.LOGIN_AUTH_TOKEN_OIDC, null, 'login-callback-spin'));
  }, []);

  return (
    <>
      <Spinner name="login-callback-spin" />
      <div style={{ textAlign: 'center', marginTop: 16 }}>{T.t('gen_page_refreshing')}</div>
    </>
  );
};

const dispatchProps = (dispatch: any) => ({ dispatch });

const OidcLoginPage = connect(undefined, dispatchProps)(IOidcLoginPage);

export default OidcLoginPage;
